import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=ca9d2dc4&scoped=true&"
var script = {}
import style0 from "./Rodape.vue?vue&type=style&index=0&id=ca9d2dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d2dc4",
  null
  
)

export default component.exports